// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__27X9g","fileBtn":"File_fileBtn__2Zs3o","closeBtn":"File_closeBtn__1Ax4Y","fileSelected":"File_fileSelected__1UaHB","disabled":"File_disabled__1MfgR"};